// extracted by mini-css-extract-plugin
export default {"titleContainer":"quotes_titleContainer__BOi8+","quotesContainer":"quotes_quotesContainer__2U8Rx"};